<div class="p-grid background-container">
  <div class="p-col-8 div-bgcolor content-container">
    <app-header></app-header>
    <router-outlet></router-outlet>
    <app-footer></app-footer>
  </div>
</div>
